// import userLogin from './Login/loginSlice';
import DashBoard from './NTX/Reports/Dashboard/dashboardSlice';
import NtxSettings from './NTX/Settings/settingsSlice';
import NtxProfile from './NTX/Profile/profileSlice';
import Employees from './HR/Person/employeeSlice';
import Absence from './HR/Person/absenceSlice';
import PersonAccrualBalance from './HR/Person/PersonAccrualBalanceSlice';
import PersonContracts from './HR/Person/contractsSlice';
import EndOfService from './HR/Person/EndOfService/endofserviceSlice';
import Lookup from './Lookup/lookupSlice';
import Lookup2 from './Lookup/lookupSlice2';
import Grades from './HR/HRSetting/jobgradeSlice';
import Jobs from './HR/HRSetting/jobSlice';
import Positions from './HR/HRSetting/positionSlice';
import Organizations from './HR/Organizations/organizationSlice';
import OrganizationStructure from './HR/Organizations/OrganizationStructureSice';
import AttendanceAdjustment from './HR/Person/AttendanceAdjustmentSlice';
import Holidays from './HR/Raqeeb/HolidaysSlice';

import Locations from './HR/HRSetting/locationSlice';
import Payrolls from './HR/Payroll/PayrollSlice';
import ElementLink from './HR/Payroll/ElementLinkSlice';
import PayrollConditions from './HR/Payroll/PayrollConditionsSlice';
import runPayroll from './HR/Payroll/runPayrollSlice';
import PyrollElement from './HR/Payroll/payrollElementSlice';
import PayProposal from './HR/Payroll/payProposalSlice';
import PayElementEntry from './HR/Payroll/payrollElementEntrySlice';
import Groups from './HR/HRSetting/groupEmpSlice';
import Assignments from './HR/Person/assignmentSlice';
import Forms from './NTX/FlexValue/Form/formSlice';
import FormColumns from './NTX/FlexValue/Form/FormColumnSlice';
import FlexValueSet from './NTX/FlexValue/flexValueSetSlice';
import FlexValue from './NTX/FlexValue/FlixValueSlice';
import Ame from './Ame/ameSlice';
import AmeDelegate from './Ame/ameDelegateSlice';
import ApprovalGroup from './Ame/approvalGroupSlice';
import ApprovalMember from './Ame/AprovalMemberSlice';
import AmeRule from './Ame/ameRuleSlice';
import AmeConditionUsage from './Ame/ameConditionUsageSlice';
import AmeActionRule from './Ame/ameActionRuleSlice';
import AmeRequest from './Ame/ameRequestSlice';
import NotificationRequest from './Ame/NotificationRequest/notificationRequestSlice';

import Users from './NTX/Security/usersSlice';
import Responsibility from './NTX/Security/responsibilitySlice';
import ResponsibilityUser from './NTX/Security/responsibilityUserSlice';
import ResponsibilityFunction from './NTX/Security/responsibilityFunctionSlice';

import Permission from './NTX/Security/Permission/PermissionSlice';
import Rules from './NTX/Security/Rules/RulesSlice';

//
// import { moduleApi } from "./moduleApi";

import Raqeeb from './HR/Raqeeb/raqeebSlice';

import ExtraInformation from './ExtraInformation/extraInformationSlice';

import RealState from './SU/realEstateSlice';
import Contracts from './SU/contractLeaseSlice';
import DashboardSU from './SU/dashboardSUSlice';
import InstallmentPayment from './SU/installmentPaymentSlice';
import Notifications from './NTX/Notifications/notificationSlice';
import Reports from './NTX/Reports/reportSlice';
import PrintTemplate from './NTX/PrintTemplate/PrintTemplateSlice';
import ReportData from './NTX/Reports/ReportData/reportdataSlice';
import ReportShape from './NTX/Reports/ReportShape/reportShapeSlice';
import Peoples from './NTX/Peoples/peoplesSlice';
import PeoplesContacts from './NTX/Peoples/PeoplesContactSlice';
import PeopleLocations from './NTX/Peoples/PeopleLocationsSlice';
import LookupData from './NTX/Lookup/lookupsSlice';

import Banks from './NTX/Banks/banksSlice';
import Currency from './NTX/Currency/currencySlice';

import WorkShop from './FLEET/Workshop/workshopSlice';
import EquipmentsModel from './FLEET/EquipmentsModel/equipmentsmodelSlice';
import Equipments from './FLEET/Equipments/equipmentsSlice';
import EquipmentsAssignment from './FLEET/EquipmentsAssignment/equipmentsAssignmentSlice';
import EquipmentsOdometer from './FLEET/EquipmentsOdometer/equipmentsOdometerSlice';
import EquipmentsWorkRequest from './FLEET/EquipmentsWorkRequests/equipmentsWorkRequestSlice';
import EquipmentsRoutes from './FLEET/EquipmentsRoutes/equipmentsRoutesSlice';
import EquipmentsWorkOrder from './FLEET/EquipmentsWorkOrder/equipmentsworkorderSlice';
import AssignmentRoutes from './FLEET/AssignmentRoutes/assignmentroutesSlice';
import FleetScan from './FLEET/FleetScan/fleetScanSlice';
import EquipmentInspection from './FLEET/EquipmentInspection/equipmentInspectionSlice';

//_Finance
import ConsolidationSet from './Finance/ConsolidationSet/consolidationSetSlice';
import TaxManager from './Finance/TaxManagers/TaxManagerSlice';
import Periods from './Finance/Periods/PeriodsSlice';
import Ledgers from './Finance/Ledgers/LedgersSlice';
import DailyRates from './Finance/DailyRates/DailyRatesSlice';
import ChartAccounts from './Finance/ChartAccounts/ChartAccountsSlice';
import ChartAccountsDetails from './Finance/ChartAccounts/ChartAccountsDetailsSlice';
import JeCategory from './Finance/JeCategory/categorySlice';
import JeSource from './Finance/JeSource/sourceSlice';
import Journals from './Finance/Journals/JournalsSlice';
import PostingJournals from './Finance/Journals/postingJournalsSlice';

import CashTransfer from './Finance/CashTransfer/CashTransferSlice';

import GlBudget from './Finance/GlBudget/GlBudgetSlice';
import CodeCombinations from './Finance/CodeCombinations/CodeCombinationsSlice';

import FinancialReports from './Finance/FinancialReports/FinancialReportsSlice';

import ApBankAccounts from './Finance/AP/ApBankAccounts/ApBankAccountsSlice';
import ApExpenseCategory from './Finance/Expense/ApExpenseCategory/ApExpenseCategorySlice';
import ApExpenseCategoryItems from './Finance/Expense/ApExpenseCategoryItems/ExpenseCategoryItemsSlice';

import ApInvoices from './Finance/AP/ApInvoices/ApInvoicesSlice';
import unpaidInvoices from './Finance/AP/ApInvoices/UnpaidInvoicesSlice';
import ApPayments from './Finance/AP/ApPayments/ApPaymentsSlice';

import ArReceipts from './Finance/AR/ArReceipts/ArReceiptsSlice';
import ArTransactions from './Finance/AR/ArTransactions/ArTransactionsSlice';

import ApExpense from './Finance/Expense/ApExpense/ApExpenseSlice';

import PaymentTerms from './Finance/PaymentTerms/PaymentTermsSlice';

import FACategories from './Finance/FixedAssets/FACategories/FACategoriesSlice';
import Assets from './Finance/FixedAssets/Assets/assetsSlice';
import Revaluation from './Finance/FixedAssets/Revaluation/RevaluationSlice';
import Retirement from './Finance/FixedAssets/Retirement/RetirementSlice';
import Depreciation from './Finance/FixedAssets/Depreciation/DepreciationSlice';
import FaAdjustment from './Finance/FixedAssets/FaAdjustment/FaAdjustmentSlice';
import FaTransfer from './Finance/FixedAssets/FaTransfer/FaTransferSlice';

//_ INV
import itemsSupplier from './INV/AssignmentItems/itemsSupplierSlice';
import Inv from './INV/Transactions/InvIssue/invSlice';
import SubInventory from './INV/SubInventory/SubInventorySlice';
import MasterItemsINV from './INV/MasterItems/MasterItemsSlice';
import LotItem from './INV/MasterItems/LotItemSlice';
import Attributes from './INV/Attributes/AttributesSlice';
import CategoriesINV from './INV/Categories/CategoriesSlice';
import ItemConversion from './INV/MasterItems/ItemConversionSlice';
import ItemComponent from './INV/MasterItems/ItemComponentSlice';
import PriceList from './INV/PriceList/PriceListSlice';
import TransactionTypes_Inv from './INV/TransactionTypes/TransactionTypesSlice';
import UnitsOfMeasure from './INV/UnitsOfMeasure/UnitsOfMeasureSlice';
import MaterialTransactions from './INV/MaterialTransactions/MaterialTransactionsSlice';

// import LookupsInventory from './INV/LookupsInventory/lookupSlice';
//
import InvIssue from './INV/Transactions/InvIssue/invIssueSlice';
import InvReceive from './INV/Transactions/InvReceive/invReceiveSlice';
import InvMove from './INV/Transactions/InvMove/invMoveSlice';
import InvUpdateCost from './INV/Transactions/UpdateCost/InvUpdateCostSlice';
import InvAllocate from './INV/Transactions/InvAllocate/InvAllocateSlice';
import InventoryCount from './INV/InventoryCount/inventoryCountSlice';

import Brand from './INV/Brands/BrandSlice';

//_ Sales
import SalesInvoices from './Sales/SalesInvoices/salesInvoicesSlice';
import SalesQuotation from './Sales/SalesQuotation/salesQuotationSlice';
import SalesOrder from './Sales/SalesOrder/SalesOrderSlice';
import DiscountVouchers from './Sales/DiscountVouchers/DiscountVouchersSlice';
import SalesReturns from './Sales/SalesReturns/salesReturnsSlice';
import Pos from './Sales/Pos/PosSlice';
import posScale from './Sales/Pos/posScaleSlice';
import PosCashier from './Sales/Pos/PosCashierSlice';
import PosPaymentMethod from './Sales/Pos/PosPaymentMethodSlice';
import PosSession from './Sales/Pos/PosSessionSlice';
import PosRegistration from './Sales/Pos/PosRegistrationSlice';
import PosSettlementType from './Sales/Pos/PosSettlement/PosSettlementTypeSlice';
import SessionSettlement from './Sales/Pos/PosSettlement/SessionSettlementSlice';
import SettlementPolicy from './Sales/Pos/SettlementPolicySlice';

//_ Purchases
import PurchaseQuotation from './purchases/PurchaseQuotation/purchaseQuotationSlice';
import PurchaseRequest from './purchases/PurchaseRequests/purchaseRequestsSlice';
import PurchaseOrder from './purchases/PurchaseOrder/purchaseOrderSlice';
import PurchaseBill from './purchases/PurchaseBill/purchaseBillSlice';
import ReturnsPurchaseOrder from './purchases/ReturnsPurchaseOrder/returnsPurchaseOrderSlice';
import ReturnsPurchase from './purchases/ReturnsPurchase/returnsPurchaseSlice';

import MrpProcesses from './MRP/Processes/ProcesseSlice';
import MrpProducts from './MRP/Products/ProductsSlice';

//Tasks
import Tasks from './Tasks/Task/taskSlice';
import TaskComment from './Tasks/TaskComment/taskCommentSlice';
import TaskAssignments from './Tasks/TaskAssignment/taskAssignmentSlice';
import TaskDependency from './Tasks/TaskDependencie/taskDependencySlice';
import TaskFollowers from './Tasks/TaskFollowers/TaskFollowersSlice';
import TaskIssue from './Tasks/TaskIssue/taskIssueSlice';
import TaskTimeEntrie from './Tasks/TaskTimeEntrie/taskTimeEntrieSlice';
import TaskLink from './Tasks/TaskLink/taskLinkSlice';
import TaskChangeRequest from './Tasks/TaskChangeRequest/taskChangeRequestSlice';
import TaskTimeline from './Tasks/Task/taskTimelineSlice';

//Projects
import ProjectDetails from './Project/projectSlice';
import ProjectBudget from './Project/projectBudgetSlice';
import ProjectContract from './Project/projectContractSlice';
import ProjectCost from './Project/projectCostSlice';
import ProjectIncident from './Project/projectIncidentSlice';
import ProjectPhase from './Project/projectPhaseSlice';
import ProjectTracking from './Project/projectTrackingSlice';

import Zatca from './Zatca/zatcaSlice';
import userLogin from './Login2/loginSlice';
import filterApi from './filterApiSlice';
import dynamicTable from './DynamicSlice/dynamicTableSlice';
import reportTable from './DynamicSlice/reportTableSlice';

import operatingUnit from './OU/operatingUnitContext';

export const rootReducer = {
  operatingUnit,
  filterApi,
  reportTable,
  dynamicTable,
  userLogin,
  DashBoard,
  NtxProfile,
  NtxSettings,
  Employees,
  Assignments,
  Absence,
  PersonAccrualBalance,
  PersonContracts,
  EndOfService,
  Lookup,
  Lookup2,
  LookupData,
  Grades,
  Jobs,
  Positions,
  Organizations,
  OrganizationStructure,
  Locations,
  Payrolls,
  ElementLink,
  PayrollConditions,
  runPayroll,
  PyrollElement,
  PayProposal,
  PayElementEntry,
  Groups,
  ////////
  ExtraInformation,
  Forms,
  FlexValueSet,
  FlexValue,
  FormColumns,
  Ame,
  AmeDelegate,
  ApprovalGroup,
  ApprovalMember,
  AmeRule,
  AmeConditionUsage,
  AmeActionRule,
  AmeRequest,
  NotificationRequest,
  Users,
  Responsibility,
  ResponsibilityUser,
  ResponsibilityFunction,
  Permission,
  Rules,
  //
  //
  Raqeeb,
  AttendanceAdjustment,
  Holidays,

  // SU
  RealState,
  Contracts,
  InstallmentPayment,
  DashboardSU,
  // Reports
  Reports,
  PrintTemplate,
  Notifications,
  ReportData,
  ReportShape,
  Peoples,
  PeoplesContacts,
  PeopleLocations,
  Banks,
  Currency,

  // Fleet //
  WorkShop,
  EquipmentsModel,
  Equipments,
  EquipmentsAssignment,
  EquipmentsOdometer,
  EquipmentsWorkRequest,
  EquipmentsRoutes,
  EquipmentsWorkOrder,
  AssignmentRoutes,
  FleetScan,
  EquipmentInspection,

  ////_Finance
  ConsolidationSet,
  TaxManager,
  Ledgers,
  Periods,
  DailyRates,
  ChartAccounts,
  ChartAccountsDetails,
  JeCategory,
  JeSource,
  Journals,
  PostingJournals,

  GlBudget,
  CodeCombinations,
  FinancialReports,

  CashTransfer,

  ApBankAccounts,
  ApExpenseCategory,
  ApExpenseCategoryItems,

  ApInvoices,
  unpaidInvoices,
  ApPayments,

  ArReceipts,
  ArTransactions,

  ApExpense,

  PaymentTerms,

  // FA - Assets,

  FACategories,
  Assets,
  Revaluation,
  Retirement,
  Depreciation,
  FaAdjustment,
  FaTransfer,

  //_ INV
  ItemComponent,
  itemsSupplier,
  Inv,
  SubInventory,
  CategoriesINV,
  MasterItemsINV,
  LotItem,
  Attributes,
  ItemConversion,
  PriceList,
  TransactionTypes_Inv,
  UnitsOfMeasure,
  MaterialTransactions,
  // LookupsInventory,
  //
  InvIssue,
  InvReceive,
  InvMove,
  InvUpdateCost,
  InvAllocate,
  InventoryCount,
  Brand,

  //_ Sales
  SalesInvoices,
  SalesQuotation,
  SalesOrder,
  SalesReturns,
  DiscountVouchers,
  Pos,
  posScale,
  PosCashier,
  PosPaymentMethod,
  PosSession,
  PosRegistration,
  PosSettlementType,
  SessionSettlement,
  SettlementPolicy,

  //_ Purchases
  PurchaseQuotation,
  PurchaseRequest,
  PurchaseOrder,
  PurchaseBill,
  ReturnsPurchaseOrder,
  ReturnsPurchase,

  //_ MRP
  MrpProcesses,
  MrpProducts,

  //
  Tasks,
  TaskComment,
  TaskAssignments,
  TaskDependency,
  TaskFollowers,
  TaskIssue,
  TaskTimeEntrie,
  TaskLink,
  TaskChangeRequest,
  TaskTimeline,
  //
  ProjectDetails,
  ProjectBudget,
  ProjectContract,
  ProjectCost,
  ProjectIncident,
  ProjectPhase,
  ProjectTracking,

  Zatca
};
